<template>
  <v-chip
    v-if="resolved.label && resolved.label !== '-'"
    :class="['sw-status-chip', `sw-status-chip--${resolved.tone}`]"
    size="x-small"
    variant="flat"
    label
  >
    <span class="sw-status-chip__dot" aria-hidden="true" />
    {{ resolved.label }}
  </v-chip>
  <span v-else class="sw-status-chip-empty">-</span>
</template>

<script>
import { resolveStatusChip } from "@/utils/statusChip.js";

export default {
  name: "StatusChip",

  props: {
    value: { type: [String, Number, Boolean], default: "" },
    label: { type: String, default: "" },
  },

  computed: {
    resolved() {
      return resolveStatusChip(this.value, this.label || undefined);
    },
  },
};
</script>
